import {
  PositionTeamMembersView,
  RemovePositionView,
  JaneDetailsView,
  EditJaneView,
  OpenShiftsView,
  DetailView,
} from 'pages/Settings/pages/LocationSettings/PositionsAllocation/RemovePositionModal/views';

export const RemovePositionDetailComponentMap = {
  RemovePositionView,
  PositionTeamMembersView,
  JaneDetailsView,
  EditJaneView,
  OpenShiftsView,
  DetailView,
};
export type RemovePositionDetailModalViewType = keyof typeof RemovePositionDetailComponentMap;

export const RemovePositionViewsWithTabs: RemovePositionDetailModalViewType[] = [
  'JaneDetailsView',
  'DetailView',
];
